import React from 'react';

const ContactMap = () => {
    return (
        <>
            <section className="map-area">

                    <div style={{ width: '100%' }}>
                        <iframe title="Contact" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14420.527650884424!2d82.9425935!3d25.3668951!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x71a380480bf8aa18!2sOctavia%20Hospital!5e0!3m2!1sen!2sin!4v1672907597547!5m2!1sen!2sin" style={{ width: '100%' }} height={600} allowFullScreen="" loading="lazy"></iframe>
                    </div>

            </section>
        </>
    );
};

export default ContactMap;